export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/mobile')) {
    if (to.path === '/mobile/login') {
      setPageLayout('')
      return
    }

    setPageLayout('mobile')
    return
  }

  setPageLayout('default')
})
